import * as React from "react"

const IconLogoFooter = (props) => (
  <svg
    width={74}
    height={36}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#a)">
      <path
        d="M8.677 24.132H2.696L.012 35.802h3.052l1.01-4.39H5.65l2.718 4.39h3.342l-3.047-4.647c2.703-.702 3.622-2.151 3.793-3.7.171-1.55-.693-3.326-3.781-3.326l.002.003Zm.732 3.49c-.127 1.143-1.198 1.816-2.683 1.816H4.53l.815-3.52H7.66c1.227 0 1.866.6 1.747 1.705h.002Zm7.807-3.488h3.071l-.715 3.099-1.976 8.565h-3.105l2.725-11.664Zm25.97-.646.023 12.307H40.28l.032-8.782-6.218 8.782h-2.837l-2.574-8.83-4.12 8.83H21.16l6.087-12.81c.442-.827.869-1.195 1.708-1.2.556 0 1.16.32 1.437 1.29l2.656 9.61 6.911-9.822c.588-.832 1.083-1.085 1.767-1.068.731.02 1.463.5 1.463 1.693h-.002Zm20.71 6.745c-.208 1.876 1.22 3.354 3.718 3.391a11.38 11.38 0 0 0 3.627-.488l-.593 2.564a17.47 17.47 0 0 1-3.063.293c-4.914 0-7.197-2.44-6.831-5.819.415-3.815 3.781-6.381 9.085-6.381 1.126.017 2.247.149 3.347.395l-.537 2.35a13.012 13.012 0 0 0-3.171-.362c-3.094-.024-5.304 1.52-5.58 4.057h-.002Zm-12.669 1.203 2.857-4.033.893 4.033h-3.75Zm4.794 4.362h2.967l-2.84-10.161c-.37-1.232-1.1-1.556-1.859-1.49-.476.04-.976.243-1.478.963L45.443 35.8h3.023l1.498-2.39h5.491l.571 2.397-.005-.01ZM61.24 9.695c-.622.212-28.074 7.806-28.476 7.901a1.62 1.62 0 0 1-1.586-.36c-.732-.667-.432-1.591-.224-2.06.244-.551 5.53-11.673 5.53-11.673l-21.104 8.848c-.88.308-1.181-.417-1.181-.417s-.368-.802.593-1.256L37.966.268c.38-.17 1.096-.507 1.652 0 .556.508.339 1.274.168 1.747-.083.225-3.879 10.768-3.879 10.768S58.5 3.09 59.232 2.813c1.431-.544 2.734-.222 3.659.856a4 4 0 0 1 .793 3.608c-.32 1.09-1.025 1.925-2.44 2.408l-.005.01Z"
        fill="#A9AFD9"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h73.186v36H0z" />
      </clipPath>
    </defs>
  </svg>
)

export default IconLogoFooter
